// extracted by mini-css-extract-plugin
export default {"Popup":"style_Popup__r5Peq","button":"style_button__UCoa4","text":"style_text__e3pp5"};